export default {
  mounted() {
    document.getElementsByTagName('html')[0].classList.add('overflow-hidden');
  },
  beforeDestroy() {
    document.getElementsByTagName('html')[0].classList.remove('overflow-hidden');
  },
};
